import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SummaryChartState {
  aggregation_type: string;
  time_frames: string;
  colors: boolean;
}

export const initialState: SummaryChartState = {
  aggregation_type: "week",
  time_frames: "6",
  colors: false,
};

export const summaryChartSlice = createSlice({
  name: "summaryChart",
  initialState,
  reducers: {
    changeSummaryChartTimeFrames: (
      state: SummaryChartState,
      action: PayloadAction<string>
    ) => {
      state.time_frames = action.payload;
    },
    changeColorState: (
      state: SummaryChartState,
      action: PayloadAction<boolean>
    ) => {
      state.colors = action.payload;
    },
    changeSummaryChartAggregationType: (
      state: SummaryChartState,
      action: PayloadAction<string>
    ) => {
      state.aggregation_type = action.payload;
    },
  },
});

export const {
  changeSummaryChartAggregationType,
  changeSummaryChartTimeFrames,
  changeColorState,
} = summaryChartSlice.actions;
